import { useContext, useEffect } from 'react'
import Button from '~/src/components/mui-wrappers/buttons/Button'
import ResponsiveDialogContext, {
  ResponsiveDialogContextInterface
} from '~/src/components/mui-wrappers/responsive-dialog/ResponsiveDialogContext'
import { useEoValue } from '~/src/hooks/useEoState'
import { useTranslations } from '~/src/hooks/useTranslations'
import { FIRM_SELECTOR } from '~/src/stores/firm'

const OrderingMethodsDialogActions = () => {
  const { t } = useTranslations()  
  const firm = useEoValue(FIRM_SELECTOR)
  const responsiveDialogContext = useContext<ResponsiveDialogContextInterface>(ResponsiveDialogContext)

  useEffect(() => {
    if (!responsiveDialogContext.toggleClose) {
      return
    }

    responsiveDialogContext.toggleClose()
  }, [ firm ])

  return (
    <Button
      fullWidth
      variant='contained'
      onClick={responsiveDialogContext.toggleClose}
    >
      {t('actions.confirm')}
    </Button>
  )
}

export default OrderingMethodsDialogActions
